/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeroGame } from './HeroGame';
import {
    HeroGameFromJSON,
    HeroGameFromJSONTyped,
    HeroGameToJSON,
    HeroGameToJSONTyped,
} from './HeroGame';

/**
 * 
 * @export
 * @interface GetHeroGamesResponse
 */
export interface GetHeroGamesResponse {
    /**
     * 
     * @type {Array<HeroGame>}
     * @memberof GetHeroGamesResponse
     */
    games: Array<HeroGame>;
}

/**
 * Check if a given object implements the GetHeroGamesResponse interface.
 */
export function instanceOfGetHeroGamesResponse(value: object): value is GetHeroGamesResponse {
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function GetHeroGamesResponseFromJSON(json: any): GetHeroGamesResponse {
    return GetHeroGamesResponseFromJSONTyped(json, false);
}

export function GetHeroGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHeroGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'games': ((json['games'] as Array<any>).map(HeroGameFromJSON)),
    };
}

export function GetHeroGamesResponseToJSON(json: any): GetHeroGamesResponse {
    return GetHeroGamesResponseToJSONTyped(json, false);
}

export function GetHeroGamesResponseToJSONTyped(value?: GetHeroGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'games': ((value['games'] as Array<any>).map(HeroGameToJSON)),
    };
}

